import Rails from '@rails/ujs';

export default class BackofficeAllCustomersIndex {
  constructor() {
    this.currentCustomerId = null;
    this.currentEntityId = null;
    this.bindEvents();
  }

  bindEvents() {
    $(document).on('click', '.edit-role-btn', this.openEditRoleModal.bind(this));
    $(document).on('click', '.assign-entity-btn', this.openAssignEntityModal.bind(this));
    $(document).on('click', '#save-role-btn', this.saveRole.bind(this));
    $(document).on('click', '#assign-entity-btn', this.assignEntity.bind(this));
    $(document).on('change', '#edit-role-entity-select', this.onEntitySelectChange.bind(this));
    $(document).on('change', '#assign-entity-select', this.onAssignEntitySelectChange.bind(this));
  }

  openEditRoleModal(e) {
    const $btn = $(e.currentTarget);
    this.currentCustomerId = $btn.data('customer-id');
    const customerName = $btn.data('customer-name');
    const entities = $btn.data('entities');
    this.editEntitiesData = entities;

    $('#edit-role-customer-name').text(customerName);

    const $entitySelect = $('#edit-role-entity-select');
    $entitySelect.empty();

    entities.forEach((entity) => {
      $entitySelect.append(`<option value="${entity.id}" data-role-id="${entity.role_id}">${entity.name}</option>`);
    });

    if (entities.length > 0) {
      this.currentEntityId = entities[0].id;
      this.populateEditRoleSelect(entities[0].roles, entities[0].role_id);
    }

    $('#edit-role-modal').modal('show');
  }

  populateEditRoleSelect(roles, selectedRoleId) {
    const $roleSelect = $('#edit-role-select');
    $roleSelect.empty();

    roles.forEach((role) => {
      $roleSelect.append(`<option value="${role.id}">${role.name}</option>`);
    });

    if (selectedRoleId) {
      $roleSelect.val(selectedRoleId);
    }
  }

  onEntitySelectChange(e) {
    const $selected = $(e.currentTarget).find(':selected');
    this.currentEntityId = $selected.val();
    const roleId = $selected.data('role-id');
    
    const entity = this.editEntitiesData.find(ent => ent.id == this.currentEntityId);
    if (entity) {
      this.populateEditRoleSelect(entity.roles, roleId);
    }
  }

  openAssignEntityModal(e) {
    const $btn = $(e.currentTarget);
    this.currentCustomerId = $btn.data('customer-id');
    const customerName = $btn.data('customer-name');

    $('#assign-entity-customer-name').text(customerName);
    
    const $entitySelect = $('#assign-entity-select');
    $entitySelect.val($entitySelect.find('option:first').val());
    
    this.populateAssignRoleSelect();

    $('#assign-entity-modal').modal('show');
  }

  onAssignEntitySelectChange() {
    this.populateAssignRoleSelect();
  }

  populateAssignRoleSelect() {
    const $selected = $('#assign-entity-select').find(':selected');
    const rolesData = $selected.data('roles');
    const roles = typeof rolesData === 'string' ? JSON.parse(rolesData) : rolesData;

    const $roleSelect = $('#assign-role-select');
    $roleSelect.empty();

    if (roles && roles.length > 0) {
      roles.forEach((role) => {
        $roleSelect.append(`<option value="${role.id}">${role.name}</option>`);
      });
    }
  }

  saveRole() {
    const roleId = $('#edit-role-select').val();
    const entityId = this.currentEntityId;
    const $table = $('#basic-datatable');
    const url = $table.data('update-role-url').replace(':id', this.currentCustomerId);

    $('#save-role-btn').prop('disabled', true);

    Rails.ajax({
      url: url,
      type: 'PUT',
      data: `entity_id=${entityId}&role_id=${roleId}`,
      success: (data) => {
        $('#edit-role-modal').modal('hide');
        this.showNotification('success', data.message);
        const $row = $(`tr[data-customer-id="${this.currentCustomerId}"]`);
        $row.find('.customer-role-display').text(data.role_name);

        const $btn = $row.find('.edit-role-btn');
        const entities = $btn.data('entities');
        const updatedEntities = entities.map(entity => {
          if (entity.id == entityId) {
            entity.role_id = Number.parseInt(roleId);
          }
          return entity;
        });
        $btn.data('entities', updatedEntities);
      },
      error: (xhr) => {
        const response = JSON.parse(xhr.response);
        this.showNotification('error', response.error || 'An error occurred');
      },
      complete: () => {
        $('#save-role-btn').prop('disabled', false);
      }
    });
  }

  assignEntity() {
    const entityId = $('#assign-entity-select').val();
    const roleId = $('#assign-role-select').val();
    const $table = $('#basic-datatable');
    const url = $table.data('assign-entity-url').replace(':id', this.currentCustomerId);

    $('#assign-entity-btn').prop('disabled', true);

    Rails.ajax({
      url: url,
      type: 'POST',
      data: `entity_id=${entityId}&role_id=${roleId}`,
      success: (data) => {
        $('#assign-entity-modal').modal('hide');
        this.showNotification('success', data.message);
        window.location.reload();
      },
      error: (xhr) => {
        const response = JSON.parse(xhr.response);
        this.showNotification('error', response.error || 'An error occurred');
      },
      complete: () => {
        $('#assign-entity-btn').prop('disabled', false);
      }
    });
  }

  showNotification(type, message) {
    if (typeof $.NotificationApp !== 'undefined') {
      $.NotificationApp.send(
        type === 'success' ? 'Succès' : 'Erreur',
        message,
        'top-right',
        'rgba(0,0,0,0.2)',
        type
      );
    } else {
      alert(message);
    }
  }

  onDataChanged(data) {
  }

  onDestroy() {
    $(document).off('click', '.edit-role-btn');
    $(document).off('click', '.assign-entity-btn');
    $(document).off('click', '#save-role-btn');
    $(document).off('click', '#assign-entity-btn');
    $(document).off('change', '#edit-role-entity-select');
    $(document).off('change', '#assign-entity-select');
  }
}
